window.docReady(() => {
  window.bootstrapValidation("#password-reset-form", {
    Username: (element) => {
      const errors = [];
      const { validity } = element;
      
      if (validity.valueMissing) {
        errors.push("Please enter an email address");
      }
      if (validity.typeMismatch) {
        errors.push("Please enter a valid email address");
      }
      
      return errors;
    },
  }, window.errors);
});